"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdReactRouter = require("cccisd-react-router");
var _CurriculumMediator = _interopRequireDefault(require("./CurriculumMediator"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var MediatorRoot = function MediatorRoot(ownProps) {
  return /*#__PURE__*/_react["default"].createElement(_cccisdReactRouter.Route, {
    path: "".concat(ownProps.match.url, "/:currentDeploymentId?"),
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_CurriculumMediator["default"], _extends({}, ownProps, {
        basePath: ownProps.match.url
      }));
    }
  });
};
var _default = exports["default"] = (0, _cccisdReactRouter.withRouter)(MediatorRoot);